import { useMemo } from 'react'

import { useTranslation } from 'services/i18n'

import { Conversation } from 'types/Api'

import { ConversationsGroupAccordion } from './ConversationsGroupAccordion'
import { getConversationsSortedByDate } from './utils'

import type { ComponentProps, FC } from 'react'

type Props = {
  conversations: Conversation[]
} & Omit<ComponentProps<typeof ConversationsGroupAccordion>, 'conversations' | 'title'>

export const PinnedConversations: FC<Props> = ({
  activeConversationId,
  conversations,
  onSelectConversation,
  onClickDeleteConversation,
  onTriggerEvent,
}) => {
  const { t } = useTranslation()

  const pinnedConversationsSortedByDate = useMemo(
    () => getConversationsSortedByDate(conversations),
    [conversations],
  )

  if (!pinnedConversationsSortedByDate.length) return null

  return (
    <>
      <ConversationsGroupAccordion
        activeConversationId={activeConversationId}
        conversations={pinnedConversationsSortedByDate}
        isPinnedConversations
        onSelectConversation={onSelectConversation}
        onClickDeleteConversation={onClickDeleteConversation}
        onTriggerEvent={onTriggerEvent}
        title={t('conversation_history.pinned')}
      />
      <div className="m-2 border-b border-light" />
    </>
  )
}
